import { Reveal } from "./Reveal";
import { STORIES, IMAGES, CLINIC } from "../lib/content";
import { Quote } from "lucide-react";

export default function Stories() {
  return (
    <section id="stories" className="py-24 md:py-32 bg-secondary/25 relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 items-start">
          <Reveal className="lg:sticky lg:top-28">
            <span className="overline text-accent">Success stories</span>
            <h2 className="font-serif text-primary text-4xl sm:text-5xl tracking-tight leading-[1.02] mt-5">
              Words from the women we&rsquo;ve walked beside.
            </h2>
            <p className="mt-6 text-muted-foreground leading-relaxed max-w-md">
              Real experiences from patients of {CLINIC.doctor} — {CLINIC.experience} of practice at Mom &amp; More Clinic and beyond.
            </p>
            <div className="mt-8 overflow-hidden rounded-[1.5rem] border border-border" style={{ aspectRatio: "16/11" }}>
              <img src={IMAGES.care} alt="Mother and baby care" className="w-full h-full object-cover" />
            </div>
          </Reveal>

          <div className="grid gap-5">
            {STORIES.map((s, i) => (
              <Reveal key={s.name} delay={i * 0.08}>
                <figure
                  data-testid={`testimonial-${i}`}
                  className="p-7 sm:p-8 rounded-2xl bg-card border border-border hover:-translate-y-1 transition-transform duration-300"
                >
                  <Quote className="text-secondary" size={28} />
                  <blockquote className="font-serif text-xl sm:text-2xl text-foreground leading-snug mt-4">
                    &ldquo;{s.quote}&rdquo;
                  </blockquote>
                  <figcaption className="mt-5 flex items-center gap-3">
                    <span className="w-9 h-9 rounded-full bg-primary text-primary-foreground grid place-items-center text-sm font-semibold">
                      {s.name.charAt(0)}
                    </span>
                    <span>
                      <span className="block font-semibold text-foreground text-sm">{s.name}</span>
                      <span className="block text-xs text-muted-foreground">{s.treatment}</span>
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
